import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  tryCreateCourse,
  tryUploadCourseProgram,
  selectNewCourse,
} from "../../../store/slices/back-course";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { GridCloseIcon } from "@mui/x-data-grid";
import ModalMessages from "../../layout/modal-messages";
import BackCoursesComplementsDrawerSkeleton from "../skeleton/drawerSkeleton";

const ComplementsDrawer = ({
  openDrawer,
  setOpenDrawer,
  title,
  id,
  values,
  openDialog,
  setOpenDialog,
  courseDetail,
}) => {
  const dispatch = useDispatch();

  const newCourseState = useSelector(selectNewCourse);
  const newCourse = useSelector(selectNewCourse);

  const [value, setValue] = useState("");
  const [pdfBase64, setPdfBase64] = useState("");
  const [pdfFileName, setPdfFileName] = useState("");

  const model = { ...courseDetail.data };
  const validateFees = false;

  useEffect(() => {
    setValue(values);
    setPdfBase64("");
    setPdfFileName("");
  }, [openDrawer]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPdfFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setPdfBase64(reader.result);
      };
      reader.onerror = (error) => {
        console.error("Error leyendo el archivo:", error);
        setPdfBase64("");
        setPdfFileName("");
      };
    }
  };

  //Se prepara el modelo que se le va a entregar a la api y se envia

  const saveComplement = async () => {
    switch (id) {
      case 1:
        model.program = value;
        break;
      case 2:
        model.bibilography = value;
        break;
      case 3:
        model.fundaments = value;
        break;
      case 4:
        model.objectives = value;
        break;
      case 5:
        model.methodologyDescription = value;
        break;
      case 6:
        model.requirements = value;
        break;
      case 7:
        model.approvalConditions = value;
        break;
    }
    const action = await dispatch(tryCreateCourse({ model, validateFees }));

    if (action.payload.data.isValid) {
      const savedCourseId =
        action.payload.data.data?.courseId || courseDetail.data.courseId;

      if (id === 1 && pdfBase64) {
        const uploadAction = await dispatch(
          tryUploadCourseProgram({
            courseId: savedCourseId,
            fileBase64: pdfBase64,
            fileName: pdfFileName,
          })
        );

        if (!uploadAction.payload?.data?.isValid) {
          return;
        }
      }

      setOpenDrawer(false);
      setOpenDialog(true);
      setPdfBase64("");
      setPdfFileName("");
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={openDrawer}
        PaperProps={{
          sx: { zIndex: 1203, width: 500, boxSizing: "border-box" },
        }}
        onClose={() => setOpenDrawer(false)}
        sx={{
          zIndex: 1203,
          width: 500,
          flexShrink: 0,
        }}
      >
        <Grid container p={1}>
          <Grid item xs={10}>
            <Typography
              variant="h4"
              align="left"
              sx={{
                paddingLeft: 1,
                paddingRight: 5,
                paddingBottom: 1,
                paddingTop: 4,
                fontWeight: "bold",
                fontSize: 20,
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                paddingLeft: 1,
                paddingRight: 5,
                paddingBottom: 3,
                paddingTop: 1,
              }}
            >
              Por favor, complete información del campo requerido
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ textAlign: "end" }}>
            <IconButton
              sx={{ color: "white" }}
              onClick={() => setOpenDrawer(false)}
            >
              <GridCloseIcon />
            </IconButton>
          </Grid>
        </Grid>
        {newCourseState.isLoading ? (
          <BackCoursesComplementsDrawerSkeleton />
        ) : (
          <Grid
            container
            rowSpacing={3}
            spacing={3}
            paddingTop={6}
            paddingLeft={4}
            paddingRight={4}
            paddingBottom={6}
            sx={{ backgroundColor: "white" }}
          >
            {id === 1 && (
              <Grid item xs={12} sx={{ textAlign: "left" }}>
                <Button
                  variant="outlined"
                  component="label"
                  startIcon={<CloudUpload />}
                  sx={{ marginBottom: 1 }}
                >
                  Cargar PDF del Programa
                  <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={handleFileUpload}
                  />
                </Button>
                {pdfFileName ? (
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Archivo seleccionado (sin guardar): {pdfFileName}
                  </Typography>
                ) : courseDetail.data?.nameFile ? (
                  <Typography variant="body2" sx={{ mt: 1, color: "success.main", fontWeight: "bold" }}>
                    ✓ Programa cargado
                  </Typography>
                ) : null}
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                label="Texto"
                value={value}
                onChange={(event) => setValue(event.target.value)}
                multiline
                rows={id === 1 ? 14 : 20}
                variant="outlined"
                sx={{ width: "100%" }}
                error={id === 1 ? !value && !pdfBase64 : !value}
              />
            </Grid>

            <Grid item xs={6} align="right" marginTop={3}>
              <Button
                disabled={id === 1 ? !value && !pdfBase64 : !value}
                variant="contained"
                onClick={() => saveComplement()}
              >
                GUARDAR
              </Button>
            </Grid>
            <Grid item xs={6} marginTop={3}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => setOpenDrawer(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        )}
        {newCourse.errors && newCourse.errors.length > 0 && (
          <ModalMessages errors={newCourse.errors} />
        )}
      </Drawer>
      {openDialog && (
        <>
          <Dialog
            open={openDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"La información ha sido guardada con éxito"}
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)} autoFocus>
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>{" "}
        </>
      )}
    </>
  );
};

export default ComplementsDrawer;
